import '@babel/polyfill';
// Import Component hooks before component definitions
import './component-hooks';
import Vue from 'vue';
import './plugins/vuetify';
import './plugins/vee-validate';
import App from './App.vue';
import router from '@/router';
import store from '@/store';
import './registerServiceWorker';
import 'vuetify/dist/vuetify.min.css';
import vuetify from '@/plugins/vuetify';
import {i18n} from '@/lang';
import VueMaterial from 'vue-material';


import '@mdi/font/css/materialdesignicons.css'; // Ensure you are using css-loader
import './theme/default.sass';

import {VueFormBuilderPlugin} from 'v-form-builder';
// import 'v-form-builder/dist/v-form-builder.css'; // load CSS from your App
import 'vue-material/dist/vue-material.min.css';
import 'vue-material/dist/theme/default.css';
import 'v-form-builder/dist/v-form-builder.css';
import '@/theme/default.sass';
import {
    dropdownControl,
    fileUploadControl,
    switchControl,
    textFieldControl,
    datePickerControl,
    customTextArea
} from '@/components/custom-controls';
import {VueMaskDirective} from 'v-mask';
import JsonExcel from 'vue-json-excel';
import '@/plugins/dayjs';
// import * as Sentry from '@sentry/vue';
import vMultiselectListbox from 'vue-multiselect-listbox'
import 'vue-multiselect-listbox/dist/vue-multi-select-listbox.css';
import {envName} from "@/env";

Vue.component('v-multiselect-listbox', vMultiselectListbox)
Vue.component('downloadExcel', JsonExcel);

Vue.config.productionTip = false;
Vue.prototype._i18n = i18n;

Vue.directive('mask', VueMaskDirective);
Vue.use(VueMaterial);
Vue.use(VueFormBuilderPlugin, {
    controls: {
        datePickerControl,
        fileUploadControl,
        dropdownControl,
        textFieldControl,
        customTextArea,
        switchControl,
    },
});


// if (envName === 'production') {
// Sentry.init({
//     Vue: Vue,
//     dsn: 'https://74b3335ca84447d0bddefa9d000b3849@o4505111960158208.ingest.sentry.io/4505111977197568',
//     // integrations: [
//     //     new Sentry.BrowserTracing({
//     //         routingInstrumentation: Sentry.vueRouterInstrumentation(router),
//     //     }),
//     //     new Sentry.Replay(),
//     // ],
//     // Performance Monitoring
//     tracesSampleRate: 1.0, // Capture 100% of the transactions, reduce in production!
//     // Session Replay
//     replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
//     replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
// });
// }


// Cria eventos globais para serem escutados pela app
export const eventBus = new Vue();
Vue.prototype.$eventBus = eventBus;


// @ts-ignore
new Vue({
    i18n,
    router,
    vuetify,
    store,
    render: (h) => h(App),
}).$mount('#app');
